import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-transaction-history',
  templateUrl: 'modal-notification-transaction-history.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss'
  ]
})
export class ModalNotificationTransactionHistoryComponent {
}
